// Copyright 2024, Imprivata, Inc.  All rights reserved.

import en from './translations/en.json';
import es from './translations/es.json';
import ar from './translations/ar.json';
import fr from './translations/fr.json';
import de from './translations/de.json';
import it from './translations/it.json';
import pt from './translations/pt.json';
import nl from './translations/nl.json';
import sv from './translations/sv.json';
import fi from './translations/fi.json';
import da from './translations/da.json';
import cs from './translations/cs.json';
import no from './translations/no.json';

export const defaultNS = 'translation' as const;
export const ns = ['translation'];

export const resources = {
  en: { translation: en },
  es: { translation: es },
  ar: { translation: ar },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  pt: { translation: pt },
  nl: { translation: nl },
  sv: { translation: sv },
  fi: { translation: fi },
  da: { translation: da },
  cs: { translation: cs },
  no: { translation: no },
} as const;

export enum ContextNames {}
